import { CalendarCheck, Phone } from "lucide-react";
import { PHONE, scrollToBooking } from "@/lib/clinic";

export const MobileBookBar = ({ fee }) => (
  <div className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-md border-t border-slate-200 p-3 flex gap-2" data-testid="mobile-book-bar">
    <a href={`tel:${PHONE}`} className="h-12 w-12 shrink-0 rounded-full border border-teal/20 grid place-items-center text-teal" data-testid="mobile-call-button" aria-label="Call clinic">
      <Phone className="h-5 w-5" />
    </a>
    <button type="button" onClick={scrollToBooking} data-testid="mobile-book-button"
      className="flex-1 h-12 rounded-full bg-teal text-white font-semibold inline-flex items-center justify-center gap-2">
      <CalendarCheck className="h-5 w-5" /> Book Appointment · ₹{fee}
    </button>
  </div>
);
